import {
  basketOutline,
  basketSharp,
  cashOutline,
  cashSharp,
  documentTextOutline,
  documentTextSharp,
  homeOutline,
  homeSharp,
  peopleOutline,
  peopleSharp,
  receiptOutline,
  receiptSharp,
  settingsOutline,
  settingsSharp,
} from 'ionicons/icons';

export interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

export enum PATHS {
  HOME = '/',
  SALES = '/sales',
  DELIVERIES = '/deliveries',
  SALES_VIEW = '/sales/view',
  CUSTOMERS = '/customers',
  COMPANIES = '/companies',
  PRODUCTS = '/products',
  CLONE_PRODUCT = '/products/clone',
  MONEY_COLLECTION = '/money-collection',
  CREATE_SUB_PATH = 'create',
  SHARED_DOC = '/share/doc',
  SHARED_MONEY_COLLECTION = '/share/money-collection',
  CLONE_SALE = '/sales/clone',
  CORRELATE_SALE = '/sales/correlate',
  SALES_VIEW_BY_MARK = '/sales/mark',
  EDIT_SALE = '/sales/edit',
  CLONE_MONEY_COLLECTION = '/money-collection/clone',
  REPORTS = '/reports',
  SETTINGS = '/settings',
  LOADING = '/loading',
  RECEIVED_DOCS = '/received-docs',
}

export const navigationData = [
  {
    title: 'TABS.SALES',
    url: PATHS.SALES,
    iosIcon: receiptOutline,
    mdIcon: receiptSharp,
  },
  {
    title: 'TABS.CUSTOMERS',
    url: PATHS.CUSTOMERS,
    iosIcon: peopleOutline,
    mdIcon: peopleSharp,
  },
  {
    title: 'TABS.PRODUCTS',
    url: PATHS.PRODUCTS,
    iosIcon: basketOutline,
    mdIcon: basketSharp,
  },
  {
    title: 'TABS.MONEY_COLLECTION',
    url: PATHS.MONEY_COLLECTION,
    iosIcon: cashOutline,
    mdIcon: cashSharp,
  },
  {
    title: 'TABS.REPORTS',
    url: PATHS.REPORTS,
    iosIcon: '/assets/img/reports.svg',
    mdIcon: '/assets/img/reports.svg',
  },
  {
    title: 'TABS.DELIVERIES',
    url: `${PATHS.DELIVERIES}/create`,
    iosIcon: '/assets/img/deliveries.svg',
    mdIcon: '/assets/img/deliveries.svg',
  },
  {
    title: 'TABS.RECEIVED_DOCS',
    url: PATHS.RECEIVED_DOCS,
    iosIcon: documentTextOutline,
    mdIcon: documentTextSharp,
  },
  {
    title: 'TABS.SETTINGS',
    url: PATHS.SETTINGS,
    iosIcon: settingsOutline,
    mdIcon: settingsSharp,
  },
];

export const appPagesMenu: AppPage[] = [
  {
    title: 'TABS.HOME',
    url: PATHS.HOME,
    iosIcon: homeOutline,
    mdIcon: homeSharp,
  },
  ...navigationData,
];

export const indexOfPlanSensitivePages = [3, 4];
